import React, { useState } from "react";
import logo from "../imgs/Logo CodeSour.png";
import { service } from "../services/service";

import { GoogleLogin } from "@react-oauth/google";
import { jwtDecode } from "jwt-decode";

import { Button, Card, Col, Row, Form, Input, Spin, message } from "antd";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [spin, setSpin] = useState(false);

  function onLogin() {
    setSpin(true);
    service.login(email, password).then((res) => {
      if (res.length === 0) {
        alert("email o password errati");
        setSpin(false);
      }
    });
  }

  const onFinish = (values) => {
    console.log("Success:", values);
  };

  const onFinishFailed = (errorInfo) => {
    console.error("Failed:", errorInfo);
  };

  function googleLogin(account) {
    if ((account.email_verified = true)) {
      window.localStorage.setItem("user", account.email);
      service.googleLogin(account);
    } else {
      message.error("account not found!");
    }
  }

  return (
    <>
      <Row>
        <Col span={24} sm={{ span: 6, offset: 9 }}>
          <Row>
            <Col span={12} offset={6}>
              <img src={logo} alt="Logo" height="auto" width="100%" />
            </Col>
          </Row>
          <Card style={{ paddingTop: "2em", paddingBottom: "2em" }}>
            {!spin ? (
              <Form
                name="basic"
                layout="vertical"
                initialValues={{
                  remember: true,
                }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete="on"
              >
                <Row gutter={16}>
                  <Col span={24}>
                    <Form.Item
                      label="E-mail"
                      name="email"
                      rules={[{ required: true }]}
                    >
                      <Input
                        placeholder="Insert E-mail"
                        onChange={(event) => {
                          setEmail(event.target.value);
                        }}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item
                      label="Password"
                      name="password"
                      rules={[
                        {
                          required: true,
                          message: "Please input your password!",
                        },
                      ]}
                    >
                      <Input.Password
                        placeholder="Insert Password"
                        onChange={(event) => {
                          setPassword(event.target.value);
                        }}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row justify={"end"} gutter={16}>
                  <Col span={24}>
                    <Button
                      type="primary"
                      onClick={onLogin}
                      style={{ width: "100%" }}
                      htmlType="submit"
                    >
                      Log In
                    </Button>
                  </Col>
                </Row>
                <Row
                  style={{
                    marginTop: "40px",
                    marginBottom: "40px",
                  }}
                  justify={"center"}
                >
                  <Col span={10}>
                    <hr color="gray" borderWidth="0" background-color="gray" />
                  </Col>
                  <Col span={3}>OR</Col>
                  <Col span={10}>
                    <hr
                      color="gray"
                      borderWidth="0"
                      height="1px"
                      background-color="gray"
                    />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <GoogleLogin
                      onSuccess={(credentialResponse) => {
                        var credentialResponseDecoded = jwtDecode(
                          credentialResponse.credential
                        );
                        googleLogin(credentialResponseDecoded);
                      }}
                      onError={() => {}}
                    />
                  </Col>
                </Row>
                <Row justify={"center"}>
                  <Col style={{ marginTop: "5%" }}>
                    <p>
                      Don’t have an account?<a href="/register"> Sign up</a>
                    </p>
                  </Col>
                </Row>
              </Form>
            ) : (
              <Spin />
            )}
          </Card>
        </Col>
      </Row>
    </>
  );
}

export default Login;
